import { useFeatureToggles } from '@grandvisionhq/state';
import { EMAIL_PRESCRIPTION, EXISTING_CUSTOMER, NEW_PRESCRIPTION, PRESCRIPTION_FILE, NEW_PRESCRIPTION_AND_UPLOAD } from '../state/constants.js';

function usePrescriptionTypes() {
    const { isPrescriptionFileEnabled , featureConfigs  } = useFeatureToggles();
    const allPossibleTypes = [
        EMAIL_PRESCRIPTION,
        EXISTING_CUSTOMER,
        NEW_PRESCRIPTION,
        PRESCRIPTION_FILE,
        NEW_PRESCRIPTION_AND_UPLOAD, 
    ];
    // Check if all environment variable types are valid
    const envTypes = featureConfigs === null || featureConfigs === void 0 ? void 0 : featureConfigs.prescriptionTypesOrder;
    if (envTypes && envTypes.every((type)=>allPossibleTypes.includes(type)
    )) {
        return [
            ...envTypes
        ];
    }
    // default behavior
    const finalTypes = [
        'NewPrescription',
        'ExistingCustomer'
    ];
    if (isPrescriptionFileEnabled) {
        finalTypes.push('EmailPrescription');
    }
    return finalTypes;
}

export { usePrescriptionTypes };
//# sourceMappingURL=use-prescription-types.js.map
